import { MagnifyingGlass } from 'phosphor-react'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { cambiaArticulosPaginaActual, getArticulos, getArticulosByFamily, setBusqueda } from '../../actions/articulos'
import { setFamiliaSeleccionada } from '../../actions/familias'
import {
  anadirFiltro,
  limpiarFiltros,
  limpiarFiltrosTexto,
  quitarFiltro,
} from '../../actions/filtros'
import i18n from '../../lang/idiomas'
import Spinner from '../layout/Spinner'

const ArticulosFiltros = ({ filtro_url }) => {
  const {
    filtros,
    filtros_claves_estadisticas,
    filtros_aplicados,
    filtros_texto_aplicados,
    articulos_search,
    articulos_pagina,
    articulos_orden,
    filtros_aplicables,
    filtros_claves_aplicables,
    pedido,
    busqueda_avanzada,
    familias,
    familia_seleccionada,
    ignorar_filtro_url,
  } = useSelector(state => ({
    filtros: state.articulos.filtros,
    filtros_claves_estadisticas: state.articulos.filtros_claves_estadisticas,
    filtros_aplicados: state.articulos.filtros_aplicados,
    filtros_texto_aplicados: state.articulos.filtros_texto_aplicados,
    articulos_search: state.listadoArticulos.articulos_search,
    articulos_pagina: state.listadoArticulos.articulos_pagina,
    articulos_orden: state.listadoArticulos.articulos_orden,
    filtros_aplicables: state.listadoArticulos.articulos.filtros_aplicables,
    filtros_claves_aplicables: state.listadoArticulos.articulos.filtros_claves_aplicables,
    pedido: state.pedidos.pedido,
    busqueda_avanzada: state.listadoArticulos.articulos_advanced_search,
    familias: state.familias.familias,
    familia_seleccionada: state.familias.familia_seleccionada,
    ignorar_filtro_url: state.articulos.ignorar_filtro_url,
  }))

  const [segundoFiltro, setSegundoFiltro] = useState('')
  const [busquedaPrincipal, setBusquedaPrincipal] = useState('')
  const isFirstRender = useRef(true)

  const dispatch = useDispatch()

  // Si ignorar_filtro_url es true, tratamos filtro_url como null
  const filtro_url_efectivo = ignorar_filtro_url ? null : filtro_url

  useEffect(() => {
    // En el primer render (montaje), no resetear pagina ni refetch.
    // ListadoArticulos se encarga de la carga inicial con el offset correcto.
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
    if (filtro_url_efectivo && !filtros_aplicados.length) return
    dispatch(cambiaArticulosPaginaActual(1))
    sessionStorage.removeItem('articulos_pagina_actual')
    if (filtros_aplicados.length > 0 || filtros_texto_aplicados.length > 0 || filtro_url_efectivo) {
      dispatch(
        getArticulosByFamily(
          filtros_aplicados,
          articulos_pagina,
          articulos_orden,
          articulos_search,
          pedido.domicilio_envio,
          busqueda_avanzada.avanzada,
          busqueda_avanzada.codigo_articulo,
          busqueda_avanzada.codigo_barras,
          busqueda_avanzada.descripcion,
          busqueda_avanzada.palabras_clave,
          busqueda_avanzada.equivalentes,
        ),
      )
    } else {
      dispatch(
        getArticulos(
          articulos_search,
          articulos_pagina,
          articulos_orden,
          pedido.domicilio_envio,
          busqueda_avanzada.avanzada,
          busqueda_avanzada.codigo_articulo,
          busqueda_avanzada.codigo_barras,
          busqueda_avanzada.descripcion,
          busqueda_avanzada.palabras_clave,
          busqueda_avanzada.equivalentes,
        ),
      )
    }
  }, [filtros_aplicados, filtros_texto_aplicados, ignorar_filtro_url])

  useEffect(() => {
    if (!articulos_search) {
      setBusquedaPrincipal('')
    }

    if (!filtros_texto_aplicados.length && busquedaPrincipal !== articulos_search) {
      setBusquedaPrincipal(articulos_search)
    }
  }, [articulos_search])

  const onClick = e => {
    e.preventDefault()

    let _tipo_filtro = e.target.dataset.tipo_filtro

    if (_tipo_filtro && _tipo_filtro === 'estad') {
      let _estadistico = e.target.dataset.estadistico
      let _familia = e.target.dataset.codigo
      let _nombre = e.target.dataset.familia

      let findPos = elem => elem.estadistico === _estadistico && elem.familia === _familia

      if (filtros_aplicados.findIndex(findPos) === -1) {
        dispatch(
          anadirFiltro({
            estadistico: _estadistico,
            familia: _familia,
            nombre: _nombre,
            tipo: 'estad',
          }),
        )
        dispatch(setFamiliaSeleccionada(_estadistico, _familia, _nombre))
      }
    } else {
      let _clave_estadistica = e.target.dataset.clave_estadistica
      let _valor_clave = e.target.dataset.valor_clave
      let _nombre = e.target.dataset.nombre_clave

      let findPos = elem => elem.estadistico === _clave_estadistica && elem.familia === _valor_clave

      if (filtros_aplicados.findIndex(findPos) === -1) {
        dispatch(
          anadirFiltro({
            estadistico: _clave_estadistica,
            familia: _valor_clave,
            nombre: _nombre,
            tipo: 'clave',
          }),
        )
        dispatch(setFamiliaSeleccionada(_clave_estadistica, _valor_clave, _nombre))
      }
    }
  }

  const eliminarFiltros = e => {
    e.preventDefault()

    dispatch(setBusqueda(busquedaPrincipal ?? ''))
    dispatch(limpiarFiltros())
    dispatch(limpiarFiltrosTexto())
  }

  const eliminarFiltro = e => {
    e.preventDefault()
    const dataset = e.currentTarget.dataset
    const _estadistico = dataset?.estadistico
    const _familia = dataset?.codigo
    const _nombre = dataset?.nombre_filtro
    const _tipo_filtro = dataset?.tipo_filtro

    if (_tipo_filtro === 'search') {
      dispatch(
        quitarFiltro({
          nombre: _nombre,
          tipo: 'search',
        }),
      )

      let filtrosTextoActualizados = filtros_texto_aplicados.filter(f => f.nombre !== _nombre)

      let filtrosTexto = filtrosTextoActualizados.map(f => f.nombre)
      let nuevaBusqueda = [busquedaPrincipal, ...filtrosTexto].join(' ').trim()
      dispatch(setBusqueda(nuevaBusqueda))
    } else {
      dispatch(
        quitarFiltro({
          estadistico: _estadistico,
          familia: _familia,
          nombre: _nombre,
          tipo: 'estad',
        }),
      )
    }
  }

  const handleChangeSecondFilter = e => {
    setSegundoFiltro(e.target.value)
  }

  const handleSubmitSecondFilter = e => {
    e.preventDefault()
    const _nombre = segundoFiltro.trim() ?? ''
    const _tipo_filtro = 'search'

    if (filtros_texto_aplicados.some(f => f.nombre === _nombre)) return

    let filtrosTextoActualizados = [
      ...filtros_texto_aplicados,
      {
        nombre: _nombre,
        tipo: _tipo_filtro,
      },
    ]

    dispatch(
      anadirFiltro({
        nombre: _nombre,
        tipo: _tipo_filtro,
      }),
    )

    let filtrosTexto = filtrosTextoActualizados.map(f => f.nombre)
    let nuevaBusqueda = [busquedaPrincipal, ...filtrosTexto].join(' ').trim()
    dispatch(setBusqueda(nuevaBusqueda))

    setSegundoFiltro('')
  }

  return (
    <div
      className='col-md-4 col-lg-3 col-xl-3 leftColumn aside'
      style={{ zIndex: 200 }}>
      <Spinner showSpinner={filtros.isLoading || filtros_claves_estadisticas.isLoading}></Spinner>
      <div className='tt-btn-col-close'>
        <a href='/#'>{i18n.t('general.cerrar')}</a>
      </div>
      <div className='tt-collapse open tt-filter-detach-option'>
        <div className='tt-collapse-content'>
          <div className='filters-mobile'>
            <div className='filters-row-select'></div>
          </div>
        </div>
      </div>
      <div style={{ position: 'sticky', top: '60px' }}>
        {filtros_aplicados.length === 0 && filtros_texto_aplicados.length === 0 ? (
          ''
        ) : (
          <div className='tt-collapse open '>
            <h3 className='tt-collapse-title'>{i18n.t('articulos.filtact')}</h3>
            <div className='tt-collapse-content'>
              <ul className='tt-filter-list'>
                {filtros_aplicados && filtros_aplicados.length > 0
                  ? filtros_aplicados.map((filtro, index) => {
                      let nombre_filtro = filtro.nombre
                      if (nombre_filtro === '') {
                        let fam_sel = undefined
                        if (familias && familias.length > 0) {
                          fam_sel = familias.filter(
                            f =>
                              f.numero_tabla === parseInt(filtro.estadistico) &&
                              f.codigo_familia === filtro.familia,
                          )
                        }
                        if (fam_sel && fam_sel.length === 0 && filtros) {
                          filtros.filtros.forEach(f => {
                            if (f.estadistico === parseInt(filtro.estadistico)) {
                              fam_sel = f.familias.filter(
                                f =>
                                  f.numero_tabla === parseInt(filtro.estadistico) &&
                                  f.codigo_familia === filtro.familia,
                              )
                            }
                          })
                        }
                        if (fam_sel && fam_sel.length > 0) {
                          nombre_filtro = fam_sel[0].descripcion
                        }
                      }

                      return (
                        <li
                          className='active'
                          key={index}>
                          <a
                            href='/#'
                            data-estadistico={filtro.estadistico}
                            data-codigo={filtro.familia}
                            data-nombre_filtro={filtro.nombre}
                            data-tipo_filtro={filtro.tipo}
                            onClick={eliminarFiltro}>
                            {nombre_filtro}
                          </a>
                        </li>
                      )
                    })
                  : ''}

                {filtros_texto_aplicados && filtros_texto_aplicados.length > 0
                  ? filtros_texto_aplicados.map((filtro, index) => (
                      <li
                        className='active'
                        key={index}>
                        <a
                          href='/#'
                          data-estadistico={filtro.estadistico}
                          data-codigo={filtro.familia}
                          data-nombre_filtro={filtro.nombre}
                          data-tipo_filtro={filtro.tipo}
                          onClick={eliminarFiltro}>
                          {filtro.nombre}
                        </a>
                      </li>
                    ))
                  : ''}
              </ul>
              <a
                href='/#'
                className='btn-link-02'
                onClick={eliminarFiltros}>
                {i18n.t('articulos.limptod')}
              </a>
            </div>
          </div>
        )}
        <div className='segundo-filtro'>
          <form
            onSubmit={handleSubmitSecondFilter}
            className='form-inline form-default w-100'>
            <div className='input-group d-flex flex-column align-items-start w-100'>
              <label htmlFor='segundo-filtro-input'>
                {i18n.t('general.busqrefi').toUpperCase()}
              </label>
              <div className='d-flex w-100'>
                <input
                  id='segundo-filtro-input'
                  className='form-control'
                  type='text'
                  name='segundo-filtro'
                  placeholder={i18n.t('general.buscar')}
                  value={segundoFiltro}
                  onChange={handleChangeSecondFilter}
                />
                <button
                  type='submit'
                  className='btn'
                  disabled={!segundoFiltro.trim()}>
                  <MagnifyingGlass
                    size={20}
                    weight='bold'
                  />
                </button>
              </div>
            </div>
          </form>
        </div>
        {filtros && filtros.filtros && filtros.filtros.length > 0
          ? filtros.filtros.map((filtro, index) => {
              if (
                filtros_aplicables.some(
                  filtro_aplicable =>
                    filtro_aplicable.estadistico === filtro.estadistico &&
                    filtro.familias &&
                    filtro.familias.length > 0,
                )
              ) {
                return (
                  <div
                    key={index}
                    className='tt-collapse open '>
                    <h3 className='tt-collapse-title'>{filtro.nombre}</h3>
                    <div className='tt-collapse-content'>
                      <ul className='tt-list-row'>
                        {filtro.familias.map((familia, index) => {
                          if (
                            filtros_aplicables.some(
                              filtro_aplicable =>
                                filtro_aplicable.estadistico === filtro.estadistico &&
                                filtro_aplicable.familias.some(
                                  familia_aplicable => familia_aplicable === familia.codigo_familia,
                                ),
                            )
                          ) {
                            return (
                              <li
                                key={index}
                                className=''>
                                <a
                                  href='/#'
                                  data-familia={familia.descripcion}
                                  data-estadistico={familia.numero_tabla}
                                  data-codigo={familia.codigo_familia}
                                  data-tipo_filtro='estad'
                                  onClick={onClick}>
                                  {familia.descripcion}
                                </a>
                              </li>
                            )
                          } else {
                            return ''
                          }
                        })}
                      </ul>
                    </div>
                  </div>
                )
              } else {
                return ''
              }
            })
          : ''}

        {filtros_claves_estadisticas &&
        filtros_claves_estadisticas.filtros_claves_estadisticas &&
        filtros_claves_estadisticas.filtros_claves_estadisticas.length > 0
          ? filtros_claves_estadisticas.filtros_claves_estadisticas.map((filtro, index) => {
              if (
                filtros_claves_aplicables.some(
                  filtro_clave_aplicable =>
                    filtro_clave_aplicable.clave_estadistica === filtro.clave_estadistica,
                )
              ) {
                return (
                  <div
                    key={index}
                    className='tt-collapse open '>
                    <h3 className='tt-collapse-title'>{filtro.nombre}</h3>
                    <div className='tt-collapse-content'>
                      <ul className='tt-list-row'>
                        {filtro.claves && filtro.claves.length > 0
                          ? filtro.claves.map((clave, index) => {
                              if (
                                filtros_claves_aplicables.some(
                                  filtro_aplicable =>
                                    filtro_aplicable.clave_estadistica ===
                                      filtro.clave_estadistica &&
                                    filtro_aplicable.claves.some(
                                      valor_clave_aplicable =>
                                        valor_clave_aplicable === clave.valor_clave,
                                    ),
                                )
                              ) {
                                return (
                                  <li
                                    key={index}
                                    className=''>
                                    <a
                                      href='/#'
                                      data-nombre_clave={clave.nombre}
                                      data-clave_estadistica={clave.clave}
                                      data-valor_clave={clave.valor_clave}
                                      data-tipo_filtro='clave'
                                      onClick={onClick}>
                                      {clave.nombre}
                                    </a>
                                  </li>
                                )
                              } else {
                                return ''
                              }
                            })
                          : ''}
                      </ul>
                    </div>
                  </div>
                )
              } else {
                return ''
              }
            })
          : ''}
      </div>
    </div>
  )
}

export default ArticulosFiltros
